import { Action } from 'redux';

import { DraftsTelemetry } from '~src/drafts/telemetry/DraftsTelemetry';

import { EditWorkbook } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface EditWorkbookAction extends Action {
  workbook: IContentInfo;
  draftOrigin?: DraftsTelemetry.LocationOrigin;
}

export function editWorkbook(workbook: IContentInfo): EditWorkbookAction {
  return {
    type: EditWorkbook,
    workbook,
  };
}

export function editWorkbookDraft(workbook: IContentInfo, draftOrigin: DraftsTelemetry.LocationOrigin): EditWorkbookAction {
  return {
    type: EditWorkbook,
    workbook,
    draftOrigin
  };
}

export const isEditWorkbookAction = isActionFactory<EditWorkbookAction>(EditWorkbook);
